import { ClientGateway } from "@kex/api";

import type { BaseToken } from "./types";

import {
  cryptoCurrencyIcons,
  cryptoNetworkIcons,
  fiatCurrencyIcons,
} from "./maps";
import { networkNamesMessages } from "./messages";
export const isBaseToken = (code: string): code is BaseToken => {
  return ["BTC", "ETH", "TON", "TRX"].includes(code);
};

export const isCryptoIcon = (
  data: string,
): data is keyof typeof cryptoCurrencyIcons => {
  return Object.keys(cryptoCurrencyIcons).includes(data);
};

export const isFiatIcon = (
  data: string,
): data is keyof typeof fiatCurrencyIcons => {
  return Object.keys(fiatCurrencyIcons).includes(data);
};

export const isNetworkIcon = (
  data: string,
): data is keyof typeof cryptoNetworkIcons => {
  return Object.keys(cryptoNetworkIcons).includes(data);
};

export const isNetworkName = (
  slug: any,
): slug is ClientGateway.NetworkSlugsEnum =>
  slug && typeof slug === "string" && networkNamesMessages.hasOwnProperty(slug);
